import React from 'react';
import Modify from './modify';
import Table from './table';
import UserShape from '../../shapes/user';
import PropTypes from 'prop-types';
import { classes } from './styles/modify-table';
import { translate } from 'react-i18next';
import { Button, Input } from 'reactstrap';

class UserModifyTableView extends React.Component {

  render() {
    const {
      t,
      user,
      disabled,
      onChange,
      onAdd
    } = this.props;
    // Table props
    const {
      items,
      onSelect,
      onUnselect,
      emptyMessage
    } = this.props;
    // Modify props
    const {
      onSave,
      onCancel,
      canSave,
      onChangePassword
    } = this.props;
    const onModify = property => {
      return (value) => onChange({
        ...(user || {}),
        [property]: value
      }, property, value);
    };
    return (
      <div className={classes.outerContainer}>
        <div className={classes.headerContainer}>
          <div />
          <h3>{t('modifyTable.header')}</h3>
          <div className={classes.actionsContainer}>
            <Button
              color="danger"
              size="sm"
              disabled={disabled}
              onClick={onAdd}
            >
              {t('modifyTable.addAction')}
            </Button>
          </div>
        </div>
        <div className={classes.container}>
          <div className={classes.tableContainer}>
            <Table
              className={classes.table}
              items={items}
              onSelect={onSelect}
              onUnselect={onUnselect}
              emptyMessage={emptyMessage}
              selected={user ? user.uuid : null}
              disabled={disabled}
            />
          </div>
          <div className={classes.modifyContainer}>
            <Modify
              userName={(user ? user.userName : '') || ''}
              firstName={(user ? user.firstName : '') || ''}
              lastName={(user ? user.lastName : '') || ''}
              active={(user ? user.active : false) || false}
              onUserName={onModify('userName')}
              onFirstName={onModify('firstName')}
              onLastName={onModify('lastName')}
              onActive={onModify('active')}
              disabled={!user || disabled}
              onSave={onSave}
              onCancel={onCancel}
              canSave={canSave}
              onChangePassword={onChangePassword}
            />
          </div>
        </div>
      </div>
    )
  }

}

UserModifyTableView.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  user: UserShape,
  items: PropTypes.arrayOf(
    UserShape.isRequired
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  onUnselect: PropTypes.func.isRequired,
  emptyMessage: PropTypes.string,
  disabled: PropTypes.bool,
  filter: PropTypes.string,
  onFilter: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  canSave: PropTypes.bool.isRequired,
  onChangePassword: PropTypes.func.isRequired
};

export default translate(['user'])(UserModifyTableView);



// WEBPACK FOOTER //
// ./src/views/user/modify-table.js